import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { delByPathId, postWarehouses, postNewWarehouse } from "services/api";
import { normalizeWarehousesList } from "./operations";

export interface WarehousesState {
  warehousesList: {
    data: any;
    filterableValues: any,
    pagination: {
      total: number;
      page: number;
    },
    status: null | 'idle' | 'loading' | 'failed',
  }
}

const initialState: WarehousesState = {
  warehousesList: {
    data: [],
    filterableValues: {},
    pagination: {
      total: 0,
      page: 1,
    },
    status: null,
  },
};

export const postWarehousesAsync: any | null = createAsyncThunk(
  'warehouses/postWarehouses',
  async (data: any) => {
    const response = await postWarehouses(data);
    return response?.data;
  },
);

export const postNewWarehouseAsync: any | null = createAsyncThunk(
  'warehouses/postNewWarehouse',
  async (data: any) => {
    const response = await postNewWarehouse(data);
    return response;
  },
);

export const delByPathIdWarehouseAsync: any | null = createAsyncThunk(
  'warehouses/delByPathId',
  async (data: any) => {
    const response = await delByPathId(data.path, data.id);
    return response;
  }
);

export const warehousesSlice = createSlice({
  name: 'warehouses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postWarehousesAsync.pending, (state) => {
        state.warehousesList.status = 'loading';
      })
      .addCase(postWarehousesAsync.fulfilled, (state, action) => {
        state.warehousesList.status = 'idle';
        state.warehousesList.data = normalizeWarehousesList(action.payload);
        state.warehousesList.filterableValues = action.payload?.item?.filterableValues;
        state.warehousesList.pagination.total = action.payload?.item?.total;
      })
      .addCase(postWarehousesAsync.rejected, (state) => {
        state.warehousesList.status = 'failed';
      })
      .addCase(delByPathIdWarehouseAsync.fulfilled, (state, action) => {
        state.warehousesList.data = state.warehousesList.data.filter((item: any) => item.id !== action.meta.arg.id);
      })
  }
});

export default warehousesSlice.reducer;
